import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState, VariationGroup } from 'editor/src/store/variants/types';

const updateVariationGroupsReducer = (state: VariantsState, action: PayloadAction<VariationGroup[]>) => {
  state.variationGroups = action.payload;
};

export default updateVariationGroupsReducer;
